import React from 'react'
import PropTypes from 'prop-types'
import { Table } from 'gdpp-components/dist/cjs/components/molecules'

import Grid from '../../atoms/FoundationGrid/Grid'
import useLoading from '../../hook/useLoading'

const FundDividendItem = ({ fundName, description, tableData, index, deferLoading }) => {
  const loading = useLoading([], (parseInt(index / 4, 10) + 1) * 300, deferLoading)
  return (
    <>
      {!loading && (
        <Grid extraClasses="fil-fund__dividend-standalone">
          <div className="fil-fund__dividend-standalone__header">
            <div id={`fil-fund-${fundName}__dividend-standalone__header-title`}>{fundName}</div>
            <div
              id={`fil-fund-${fundName}__dividend-standalone__header-subtitle`}
              className="fil-fund__dividend-standalone__header-subtitle"
            >
              {description}
            </div>
          </div>
          <div className="fil-fund__dividend-standalone__table">
            <Table {...tableData} id={`fil-fund-dividend-records__tables-${fundName}`} isAutoFitWidth size="small" />
          </div>
        </Grid>
      )}
    </>
  )
}

FundDividendItem.propTypes = {
  fundName: PropTypes.string,
  description: PropTypes.string,
  tableData: PropTypes.object,
  index: PropTypes.number,
  deferLoading: PropTypes.bool
}

FundDividendItem.defaultProps = {
  fundName: '',
  description: 'PropTypes.string',
  tableData: null,
  index: 0,
  deferLoading: true
}

export default FundDividendItem
